import { Pipe, PipeTransform } from '@angular/core';

@Pipe({standalone:true,
    name: 'googleMapLink'
})
export class GoogleMapLinkPipe implements PipeTransform {

    transform(value: string): string {
        if (value == null || value.length === 0)
            return null;
        return new URL(value.replaceAll('/','').replaceAll('\n',',')+'/', 'https://www.google.com/maps/dir//').href;
    }

}
